import jszip from 'jszip'

export function checkIfNeedZip(file, filename) {
    const needZipFileExts = ['xls', 'xlsx', 'xlsm', 'xlsb', 'doc', 'docx', 'ppt', 'pptx', 'csv', 'txt', 'msg']
    const _filename = filename.split('.')
    return file.size / 1024 > 512 && needZipFileExts.includes(_filename[_filename.length - 1])
}

export function zipFile(file, filename) {
    const zip = new jszip()
    zip.file(filename, file)
    return new Promise((resolve, reject) => {
        zip.generateAsync({
            type: "blob",
            compression: 'DEFLATE',
            compressionOptions: {
                level: 9
            }
        }).then(content => {
            const fileObj = new File([content], `${filename}.zip`, {
                type: content.type
            })
            resolve(fileObj)
        }).catch(e => {
            reject(e)
        })
    })
}

export function unZipFile(blob) {
    return new Promise((resolve, reject) => {
        jszip.loadAsync(blob).then(e => {
            e.file(Object.values(e.files)[0].name).async('blob').then(res => {
                resolve(res)
            }).catch(e => {
                reject(e)
            })
        })
    })
}